import Reveal from "@/components/base/Reveal";
import { contactChannels } from "@/mocks/contato";

const TONE: Record<string, string> = {
  primary: "bg-primary-100/70 text-primary-700",
  secondary: "bg-secondary-100/70 text-secondary-700",
  accent: "bg-accent-100/70 text-accent-700",
};

export default function ContactChannels() {
  return (
    <div className="flex flex-col gap-4">
      {contactChannels.map((channel, index) => (
        <Reveal key={channel.label} delay={index * 60}>
          <article className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200">
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${
                TONE[channel.tone] ?? TONE.primary
              }`}
            >
              <i className={`${channel.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <p className="text-xs font-semibold uppercase tracking-wide text-foreground-500">
                {channel.label}
              </p>
              {channel.href ? (
                <a
                  href={channel.href}
                  {...(channel.external
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  className="mt-1 block break-words font-heading text-base font-semibold text-foreground-950 transition-colors hover:text-primary-600"
                >
                  {channel.value}
                </a>
              ) : (
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">
                  {channel.value}
                </p>
              )}
              <p className="mt-1 text-sm text-foreground-600">{channel.note}</p>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  );
}